module.exports = __webpack_public_path__ + "static/media/R_C.529f8d3c.png";